<template>
  <div
    class="paginator"
    v-if="isShowPaginator"
  >
    <router-link
      v-if="isShowFirstPage"
      class="paginator__left-arrows"
      type="button"
      v-bind:to="{ name: routeName, query: { page: 1 } }"
    />
    <router-link
      v-if="isShowLeftArrow"
      class="paginator__left-arrow"
      type="button"
      v-bind:to="{ name: routeName, query: { page: value - 1 } }"
    />
    <router-link
      v-for="page in pages"
      v-bind:key="page"
      class="paginator__item"
      exact-active-class="current"
      v-bind:to="{ name: routeName, query: { page } }"
    >{{ page }}</router-link>
    <router-link
      v-if="isShowRightArrow"
      class="paginator__right-arrow"
      type="button"
      v-bind:to="{ name: routeName, query: { page: value + 1 } }"
    />
    <router-link
      v-if="isShowLastPage"
      class="paginator__right-arrows"
      v-bind:to="{ name: routeName, query: { page: pageCount } }"
    />
  </div>
</template>

<script>
import ThePagination from '@/components/ThePagination.vue';

/**
 * @description Пагинация страниц.
 * @type {any}
 */
export default {
  extends: ThePagination,
  name: 'PaginationPage',
  props: {
    routeName: { required: true, type: String },
  },
};
</script>
